import {
  IPersonaProps,
  DropdownMenuItemType,
  IDropdownStyles,
  Dropdown,
  ResponsiveMode,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  IStackStyles,
  IStackItemStyles,
  Stack,
  IStackTokens,
  IBreadcrumbItem,
  Breadcrumb,
  getTheme,
  Icon,
  Persona,
  PersonaSize,
  Label,
  TooltipHost,
  ActionButton,
  IButtonStyles
} from "@fluentui/react";
import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { DocumentSearchRequestBuilder } from "../src/taskpane/components/directoryComponents/advancedSearch/classifier/DocumentSearchRequestBuilder";
import { FieldHelper } from "../src/taskpane/components/directoryComponents/advancedSearch/classifier/FieldHelper";
import { InputTypeFactory } from "../src/taskpane/components/directoryComponents/advancedSearch/classifier/inputTypeFactory";
import InputCreator, {
  IInputCreator
} from "../src/taskpane/components/directoryComponents/advancedSearch/inputs/factory/InputCreator";
import { GroupByHelper } from "../src/taskpane/components/helpers/groupByHelper";
import { KeyValuePairHelper } from "../src/taskpane/components/helpers/keyValuePairHelper";
import { SharepointDocumentLibraryHelper } from "../src/taskpane/components/helpers/SharepointDocumentLibraryHelper";
import {
  validPeoplePickerTypes,
  internalSharepointName,
  validPeopleInputTypes,
  advancedSearch,
  piiConfig,
  SharePointFolderContentTypeIds,
  extensions,
  sharePointInternalFileName
} from "../src/taskpane/config/constants";
import { IDocumentSearchResult } from "../src/taskpane/interfaces/advancedSearch/IDocumentSearchResult";
import { ISharepointSearchInput } from "../src/taskpane/interfaces/advancedSearch/ISharepointSearchInput";
import { IDocUrlDropdown } from "../src/taskpane/interfaces/IDocUrlDropdown";
import { IDocUrlKeyNamePair } from "../src/taskpane/interfaces/IDocUrlKeyNamePair";
import { ISiteDriveItems } from "../src/taskpane/interfaces/ISiteDriveItems";
import { ISiteInfoUrl, ISubSiteInfo } from "../src/taskpane/interfaces/ISiteInfo";
import { IUrlDropdown } from "../src/taskpane/interfaces/IUrlDropdown";
import { IUrlKeyNamePair } from "../src/taskpane/interfaces/IUrlKeyNamePair";
import { AdvancedSearchRootState } from "../src/taskpane/redux";
import { setMode } from "../src/taskpane/redux/modules/mode";
import {
  getSiteDocumentLibraryDrives,
  getJoinedTeams,
  getSubSites,
  getUserProfilePicture,
  searchSharePointSites,
  getSharePointSubsite,
  getHubSiteSites,
  getSharePointSite,
  getTeamChannelSites,
  getTeamsChannelSites,
  getOneDriveRootDetails
} from "../src/taskpane/services/GraphService";
import { PeopleCompositeServices } from "../src/taskpane/services/peopleCompositeServices";
import { SharePointCompositeService } from "../src/taskpane/services/SharePointCompositeService";
import authModule from "../utilities/AuthModule";
import { LanguageContext } from "../utilities/LocalizationModule";
import SearchGrid from "../src/taskpane/components/directoryComponents/advancedSearch/components/searchGrid";
import { IAuthAccount, IAuthTokenResultDto } from "../src/taskpane/interfaces/IAuthTokenResultDto";
import { FontWeights, mergeStyles } from "@fluentui/react/lib/Styling";
import { ModeEnumConverter } from "../src/taskpane/components/helpers/enumConvertor";
import { ModeEnum } from "../src/taskpane/components/enums/modeEnum";
import { Text } from "@fluentui/react";
import { AdvancedSearchRecentItemBuilder } from "../src/taskpane/services/builders/advancedSearchRecentItemBuilder";
import { SharePointInputTypes } from "../src/taskpane/config/sharepointConstants";
import dayjs from 'dayjs';
import { logger } from "../utilities/logger";
import { ISiteBatchInfo } from "../src/taskpane/interfaces/ISiteBatchInfo";
import advancedSearchStateManager from "./advancedSearchStateManager";
import CacheHandler from "./advancedSearchUtils";
import { IAdvancedSearchFields } from "../src/taskpane/interfaces/IAdvancedSearchFields";
import { IUserProfile } from "../src/taskpane/interfaces/IUserProfile";
import { UserModule } from "../utilities/UserModule";
import ProfilePanel from "./profilePanel";
import { IAdvancedSearchLoading, IAdvancedSearchResult } from "./AdvancedSearchInterfaces";
import { SearchReturnType, SortValEnum } from "./AdvancedSearchEnums";
import { SharepointSpServices } from "../src/taskpane/services/SharepointSpServices";
import { parseString } from "xml2js"
import { IViewsDropdown } from "../src/taskpane/interfaces/IViewsDropdown";
import { IViewExtendedInfo } from "../src/taskpane/interfaces/IViewExtendedInfo";
import { useCheckPiiMutation } from "../src/taskpane/components/_v2/redux/api/local/api-pii-slice";
import { AutomationPanel, IFileApproval } from "../src/taskpane/components/_v2/components/Panels/AutomationPanel/AutomationPanel";
import { WebPanel } from "../src/taskpane/components/_v2/_shared/WebPanel/WebPanel";
import { SharePointInputData } from "../src/taskpane/interfaces/props/SharePointInputData";
import { documentLibraryItem, SiteItem, TenantState } from "../src/taskpane/redux/models/reduxModels";
import { useQuickFilterCommandInput } from "./QuickFilterComandInput";
import { StorageHelper } from "../utilities/StorageHelper";
import { apiSearchDocuments } from "../src/taskpane/services/ApiService";
import { DOCUBIRD_LOGO, getHeaderTextColor } from "../utilities/ThemeHelper";
import { ITeamChannelSite } from "../src/taskpane/interfaces/services/ITeamChannel";
import { getLocalStorage, localStorageKeys, removeLocalStorage, setLocalStorage } from "../src/taskpane/components/helpers/localStorageHelper";
import { setOneDriveDetails } from "../src/taskpane/redux/modules/workingDirectory";
import { getExtension } from "../src/taskpane/components/helpers/stringHelper";
const searchIconSrc = require("../assets/empty_search.svg");

const theme = getTheme();

const outerStackTokens: IStackTokens = {
  childrenGap: 20
};
const inputStackTokens: IStackTokens = {
  childrenGap: 15
};

const initStackStyles: Partial<IStackStyles> = {
  root: { width: "100%", height: "100%", margin: 0, padding: 0, overflow: "auto", userSelect: "none" }
};

// const headerStackStyles: IStackItemStyles = {
//   root: {
//     height: 50,
//     width: "100%",
//     // backgroundColor: theme.palette.themeDarkAlt
//     borderBottom: "1px solid #edebe9"
//   }
// };

// const headerTextStyles = mergeStyles({
//   fontWeight: FontWeights.semibold,
// });
const getHeaderStackStyles = (appColor?: string) => {
  const headerStackStyles: IStackItemStyles = {
    root: {
      height: 50,
      width: "100%",
      borderBottom: "1px solid #edebe9",
      backgroundColor: appColor ? appColor : "#0001FF",
      color: getHeaderTextColor(appColor)
    }
  };
  return headerStackStyles;
}

const getHeaderTextStyles = (appColor?: string) => {
  return mergeStyles({
    fontWeight: FontWeights.semibold,
    color: getHeaderTextColor(appColor),
    whiteSpace: "pre"
  });
}

const headerLogoStackItemStyles: IStackItemStyles = {
  root: {
    display: "flex",
    height: "100%",
    justifyContent: "center",
    marginLeft: 20,
    "@media only screen and (max-width: 479px)": { display: "none" },
  }
};

const sharedStackItemStyles: IStackItemStyles = {
  root: {
    width: "100%"
  }
};
const headerStackItemStyles: IStackItemStyles = {
  root: {
    // color: "white",
    paddingLeft: 20,
    paddingRight: 20,
  }
};

const getCloseButtonStyles = (appColor?: string) => {
  let colorName: string = getHeaderTextColor(appColor);
  const color: string = colorName === "white" ? colorName : theme.palette.neutralPrimary;
  const closeButtonStyles: IButtonStyles = {
    root: {
      paddingRight: 12,
    },
    icon: {
      color: color,
    },
    iconHovered: {
      color: color,
    }
  };
  return closeButtonStyles;
}

const inputStackItemStyles: Partial<IStackStyles> = { root: { width: "100%", margin: 0, paddingTop: 10, paddingRight: 20, paddingLeft: 20, paddingBottom: 20, overflow: "auto" } };

const dropdownStyles: Partial<IDropdownStyles> = {
  dropdown: { width: "100%" },
  dropdownItemsWrapper: { maxHeight: 500 }
};

const inputContainerStackItemStyles: IStackItemStyles = {
  root: {
    height: "calc(100vh - 50px)", // Subtract header height
    width: 360,
    borderRight: "1px solid #edebe9",
    overflowY: "auto"
  }
};

const getEventPathIdList = (e) => {
  if ("composedPath" in e) return e.composedPath()?.map(path => path?.id);
  if ("path" in e) return e.path?.map(path => path?.id);
  //polyfill
  const path = [];
  let currentElem = e.target;
  while (currentElem) {
    path.push(currentElem?.id);
    currentElem = currentElem.parentElement;
  }
  return path;
}

const checkValueForUndefined = (value) => {
  if (value === "undefined") return undefined;
  return value;
}

const mapDispatchToProps = {
  setMode,
  setOneDriveDetails
};

const mapStateToProps = (state: AdvancedSearchRootState) => {
  return {
    datasourceValues: state.datasource.values,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface advancedSearchProps extends PropsFromRedux {
  account?: IAuthAccount;
  userProfile?: IUserProfile;
  tenantInfo?: TenantState;
  siteId?: string;
  isInConentMangerMode?: boolean;
  hubId?: string;
  teamGroupId?: string;
  teamDriveId?: string;
  teamsContext?: microsoftTeams.Context;
}

const AdvancedSearch: React.FunctionComponent<advancedSearchProps> = props => {
  const languageStrings = React.useContext(LanguageContext);

  const [appLogo, setAppLogo] = React.useState<string>(props.teamsContext ? props.tenantInfo?.appLogo : (props.tenantInfo?.appLogo || DOCUBIRD_LOGO));
  const [appColor, setAppColor] = React.useState<string>(props.teamsContext ? "#ffffff" : props.tenantInfo?.appColor);
  const [headerStackStyles, setHeaderStackStyles] = React.useState<IStackItemStyles>(getHeaderStackStyles(appColor));
  const [headerTextStyles, setHeaderTextStyles] = React.useState<string>(getHeaderTextStyles(appColor));
  const [loading, setLoading] = React.useState<IAdvancedSearchLoading>({ sites: true, documentLibraries: false, contentTypes: false, recentFiles: true, refreshingCache: false });
  const [sitesDropdown, setSitesDropdown] = React.useState<IUrlDropdown[]>([]);
  const [selectedSites, _setSelectedSites] = React.useState<IUrlKeyNamePair[]>([]);
  const [documentLibrariesDropdown, setDocumentLibrariesDropdown] = React.useState<IDocUrlDropdown[]>([]);
  const [selectedDocumentLibraries, _setSelectedDocumentLibraries] = React.useState<IDocUrlKeyNamePair[]>([]);
  const [contentTypesDropdown, setContentTypesDropdown] = React.useState<IDocUrlDropdown[]>([]);
  const [selectedContentTypes, setSelectedContentTypes] = React.useState<IDocUrlKeyNamePair[]>([]);
  const [fields, setFields] = React.useState([]);
  const [inputValuesToSearch, _setInputValuesToSearch] = React.useState<ISharepointSearchInput[]>([]);
  const [searchResult, setSearchResult] = React.useState<IAdvancedSearchResult>({
    type: null,
    result: [],
  });
  const [searching, setSearching] = React.useState({ isSearching: false, hasSearchedBefore: false });
  const [allUsers, setAllUsers] = React.useState<IPersonaProps[]>([]);
  const [isInputsLoading, setIsInputsLoading] = React.useState<boolean>(false);
  // const [params] = React.useState(new URLSearchParams(window.location.search));

  const [loadUserRecentItems, _setLoadUserRecentItems] = React.useState<boolean>(false);
  const [breadCrumbItems, setBreadCrumbItems] = React.useState<IBreadcrumbItem[]>([]);

  const [filterValue, setFilterValue] = React.useState<string>();
  const [hasTeamsAccess, setHasTeamsAccess] = React.useState<boolean>(true);
  const [allowOpenInSharePoint, setAllowOpenInSharePoint] = React.useState<boolean>(true);
  const [profilePanelIsOpen, setProfilePanelIsOpen] = React.useState(false);
  const [profilePic, setProfilePic] = React.useState("");
  const [viewsDropdownItems, setViewsDropdownItems] = React.useState<IViewsDropdown[]>([]);
  const [isApprovalsPanelOpen, setIsApprovalsPanelOpen] = React.useState(false);
  const [approvalFiles, setApprovalFiles] = React.useState<IFileApproval[]>([]);

  const [currentUserAccount, setCurrentUserAccount] = React.useState<IAuthAccount>();

  const [checkPiiMutation] = useCheckPiiMutation();

  const loadUserRecentItemsRef = React.useRef(loadUserRecentItems);
  const setLoadUserRecentItems = (value: boolean) => {
    loadUserRecentItemsRef.current = value;
    _setLoadUserRecentItems(value);
  };

  const inputValuesToSearchRef = React.useRef(inputValuesToSearch);
  const setInputValuesToSearch = (data: ISharepointSearchInput[]) => {
    inputValuesToSearchRef.current = data;
    _setInputValuesToSearch(data);
  };

  const selectedSitesRef = React.useRef(selectedSites);
  const setSelectedSites = (data: IUrlKeyNamePair[]) => {
    selectedSitesRef.current = data;
    _setSelectedSites(data);
  };

  const selectedDocumentLibrariesRef = React.useRef(selectedDocumentLibraries);
  const setSelectedDocumentLibraries = (data: IDocUrlKeyNamePair[]) => {
    selectedDocumentLibrariesRef.current = data;
    _setSelectedDocumentLibraries(data);
  };

  let initialSelectedSites: IUrlKeyNamePair[] = [];

  async function resetBreadCrumbs(): Promise<void> {
    setBreadCrumbItems([{ text: languageStrings.Recent, key: "Recent", href: "#", onClick: resetBreadCrumbs }]);
    await getRecentItems(false, loadUserRecentItemsRef?.current);
  }

  React.useEffect(() => {

    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        if (!advancedSearchStateManager.isDataSourcePanelActive && getEventPathIdList(event).some(pathId => pathId === "searchFieldContainer")) {
          event.preventDefault();
          search();
        }
      }
    };
    document.addEventListener("keydown", listener);

    const setupAsyncWrapper = async () => {
      let authResult: IAuthTokenResultDto;

      setLoading(prevLoading => ({ ...prevLoading, sites: true, recentFiles: true }));

      if (!props.isInConentMangerMode) {
        const modeParam: string = checkValueForUndefined(await StorageHelper.getItemAsync(advancedSearch.params.mode));
        const mode = ModeEnumConverter.convertNumberToEnum(+(modeParam ?? "0"), ModeEnum);
        props.setMode(mode);

        const tenantId: string = checkValueForUndefined(!props.account ? await StorageHelper.getItemAsync(advancedSearch.params.tenantId) : props.account.tenantId);
        // [authResult] = await Promise.all([setupTokens(params), advancedSearchStateManager.getTenantInfo(tenantId)]);
        [authResult] = await Promise.all([authModule.getAuthData(), advancedSearchStateManager.getTenantInfo(tenantId)]);
        setAppLogo(advancedSearchStateManager.appLogo);
        setAppColor(advancedSearchStateManager.appColor);
        setHeaderStackStyles(getHeaderStackStyles(advancedSearchStateManager.appColor));
        setHeaderTextStyles(getHeaderTextStyles(advancedSearchStateManager.appColor));
      }
      else {
        advancedSearchStateManager.getTenantInfo(null, props.tenantInfo);
      }

      setCurrentUserAccount(props.account ?? authResult.account);

      let shouldLoadRecentItems: boolean = null;
      let allowOpenInSP: boolean = true;
      const initBreadCrumbsTmp = [
        { text: languageStrings.Recent, key: "Recent", href: "#", onClick: resetBreadCrumbs }
      ]; //same format as the state breadcrumbs above

      if (props.account) { //if we are in standalone mode
        //get user settings from API
        const userProfile: IUserProfile = props.userProfile ?? await UserModule.getUserProfile(authResult.account, ModeEnum.contentManagerAdvancedSearch);
        shouldLoadRecentItems = !props.isInConentMangerMode && userProfile.settings.showRecent;
        allowOpenInSP = userProfile.tenantAllowOpenInSharePoint;
        setHasTeamsAccess(JSON.parse(await StorageHelper.getItemAsync(advancedSearch.params.hasTeamsAccess)) ?? userProfile.settings.enableTeams);
        const profileImageUrl: string = !props.isInConentMangerMode && await getUserProfilePicture(await authModule.getGraphAccessToken());
        if (profileImageUrl) {
          setProfilePic(profileImageUrl);
        }
        CacheHandler.setAccountId(props.account.accountId);
      } else {
        shouldLoadRecentItems = JSON.parse(await StorageHelper.getItemAsync(advancedSearch.params.loadUserRecentItems));
        allowOpenInSP = JSON.parse(await StorageHelper.getItemAsync(advancedSearch.params.allowOpenInSharePoint));
      }

      setAllowOpenInSharePoint(allowOpenInSP);

      setLoadUserRecentItems(shouldLoadRecentItems);
      if (shouldLoadRecentItems) {
        setBreadCrumbItems(initBreadCrumbsTmp);
      }

      getRecentItems(true, shouldLoadRecentItems);
      setLoading(prevLoading => ({ ...prevLoading, recentFiles: false }));

      await initSearchFields();
      setLoading(prevLoading => ({ ...prevLoading, sites: false }));
    };

    setupAsyncWrapper();
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  React.useEffect(() => {
    if (props.datasourceValues) {
      updateInputValuesFromDataSource(props.datasourceValues);
    }
  }, [props.datasourceValues]);

  React.useEffect(() => {
    if (!advancedSearchStateManager.enableAdvSearchMultiSites && selectedDocumentLibrariesRef?.current?.length > 0 && selectedSitesRef.current?.length > 0) {
      const asyncWrapper = async () => {
        const sharePointAccessToken: string = await authModule.getSharePointAccessToken();
        const viewsPromises = await Promise.all(selectedDocumentLibrariesRef?.current?.map(async (lib) => {
          const spService = new SharepointSpServices(lib.webUrl, sharePointAccessToken);
          const views: IViewExtendedInfo[] = (await spService.getSharePointView(lib.sharePointListId)).map(view => {
            const currSite = selectedSitesRef.current.find(site => site.siteId === lib.siteId);
            return ({
              ...view,
              Title: selectedDocumentLibrariesRef?.current?.length === 1 ? view.Title : `${view.Title} (${lib.documentLibrary})`,
              siteId: currSite?.siteId,
            });
          });
          return views;
        }));

        const views = viewsPromises.reduce((acc, val) => acc.concat(val), []);

        const xmlData: IViewsDropdown[] = [];
        // views?.filter(view => !view.Hidden)
        views?.forEach((view, index) => parseString(view.ListViewXml, (err, result) => {
          if (result) {
            xmlData.push(
              {
                Id: view.Id,
                text: view.Title,
                key: `${view.Title}-${index}`,
                query: result.View.Query[0],
                fields: result.View.ViewFields[0].FieldRef
                  .map(f => f.$),
                siteId: view.siteId,
                webUrl: result.View.$.Url,
              });
          }
          if (err) {
            logger(err, "advancedSearch.tsx (views init)");
          }
        }));
        setViewsDropdownItems(xmlData);
      }
      asyncWrapper();
    }
  }, [selectedSitesRef.current, selectedDocumentLibrariesRef?.current])

  const updateInputValuesFromDataSource = (values: any) => {
    const propertyKeys = Object.keys(values);
    const updatedinputValuesToSearch = [...inputValuesToSearchRef?.current];
    propertyKeys.forEach(propKey => updateDatasourceDisplayNameInputData(updatedinputValuesToSearch, propKey, values[propKey]));
    setInputValuesToSearch(updatedinputValuesToSearch);
  };

  const updateDatasourceDisplayNameInputData = (updatedinputValuesToSearch: ISharepointSearchInput[], propKey: string, value: any) => {
    let inputToUpdate = inputValuesToSearchRef?.current.find(
      item => item.displayName && item.displayName.split(",").some(name => name.trim().toLowerCase() === propKey.trim().toLowerCase())
    );

    if (inputToUpdate) {
      const validatedValue = validateAndTransformDatasourceValue(inputToUpdate, value);
      if (validatedValue) {
        updatedinputValuesToSearch[inputToUpdate.index].value = validatedValue;
      }
    }
  };

  const validateAndTransformDatasourceValue = (input: ISharepointSearchInput, value: any): any => {
    try {
      const inputType = input.xml?.Type?.toLowerCase();
      if (inputType == SharePointInputTypes.text.toLowerCase() || inputType == SharePointInputTypes.note.toLowerCase()) {
        return value;
      }

      if (inputType == SharePointInputTypes.choice.toLowerCase() || inputType == SharePointInputTypes.multiChoice.toLowerCase()) {
        if (Array.isArray(input.choices)) {
          const choiceValue = input.choices.find(choice => choice.toLowerCase().trim() === value.toLowerCase().trim());
          if (choiceValue) return choiceValue;
        }
      } else if (inputType == SharePointInputTypes.number.toLowerCase() || inputType == SharePointInputTypes.currency.toLowerCase()) {
        let numberValue: number = Number(value);
        if (numberValue) {
          // if (input.xml?.Min && numberValue < input.xml.Min) {
          //   return null;
          // }
          // if (input.xml?.Max && numberValue > input.xml.Max) {
          //   return null;
          // }
          if (input.xml?.Percentage === "TRUE") {
            return numberValue * 100;
          }
          return numberValue;
        }
      } else if (inputType == SharePointInputTypes.datetime.toLowerCase()) {
        return dayjs(value).isValid() ? dayjs(value).toDate() : null;
      } else if (inputType == SharePointInputTypes.Boolean.toLowerCase()) {
        switch (value.toLowerCase().trim()) {
          case "true":
            return true;
          case "false":
            return false;
          case "yes":
            return true;
          case "no":
            return false;
          case "ja":
            return true;
          case "nee":
            return false;
          default:
            return null;
        }
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (validateAndTransformDatasourceValue)");
    }

    return null;
  }

  const initSearchFields = async (isRefresh: boolean = false) => {
    try {
      const graphAccessToken: string = await authModule.getGraphAccessToken();
      const siteId: string = checkValueForUndefined(props.siteId ? props.siteId : await StorageHelper.getItemAsync(advancedSearch.params.siteId));
      const hubId: string = checkValueForUndefined(props.hubId ? props.hubId : await StorageHelper.getItemAsync(advancedSearch.params.hubId));
      const enableMultiSites: boolean = advancedSearchStateManager.enableAdvSearchMultiSites;

      let sites: ISiteInfoUrl[] = !isRefresh ? CacheHandler.getSiteAndSubsites(siteId, hubId, enableMultiSites) : [];
      if (sites.length === 0
        || CacheHandler.shouldUpdateCache()
        || (siteId && !sites.some(site => site.id === siteId))) {
        //if the current cache is out of date OR if there is no cache, we must do API call
        sites = await getCombinedSites(graphAccessToken, siteId, hubId);
        CacheHandler.setSites(sites);
      }

      setSitesDropdown(await buildSitesDropdown(sites, graphAccessToken));
      // if (!isRefresh && siteId) {
      //   await setInitialSelectedSite(graphAccessToken, sites);
      // }
      if (!isRefresh) {
        let selectedSites: ISiteInfoUrl[] = [];

        if (!siteId || enableMultiSites) {
          const selectedSiteIdList: string[] = getLocalStorage(localStorageKeys.selectedAdvSearchSites) as string[];
          if (Array.isArray(selectedSiteIdList)) {
            selectedSites = sites.filter(site => selectedSiteIdList.some(siteId => siteId === site.id));
          }
        }

        // Ensure requested site is selected
        if (siteId && selectedSites.findIndex(selectedSite => selectedSite.id === siteId) === -1) {
          const requestedSite = sites.find(site => site.id === siteId);
          if (requestedSite) {
            selectedSites.push(requestedSite);
            // Ensure all sub/channel sites are selected
            const subSites = sites.filter(site => site.id !== requestedSite.id && ((site.isChannel && site.teamSiteId === requestedSite.id) || site.webUrl.includes(requestedSite.webUrl + '/')));
            for (let i = 0; i < subSites.length; i++) {
              selectedSites.push(subSites[i]);
            }
          }
        }

        if (selectedSites.length === 0) {
          selectedSites = sites;
        }

        await setInitialSelectedSite(graphAccessToken, selectedSites);
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (initSearchFields)");
    }
  }

  const getCombinedSites = async (graphAccessToken: string, siteId: string, hubId: string): Promise<ISiteInfoUrl[]> => {
    let hasSharePointAccess: boolean;
    try {
      hasSharePointAccess = props.userProfile
        ? (props.userProfile?.settings?.enableSharePoint ?? true)
        : JSON.parse(await StorageHelper.getItemAsync(advancedSearch.params.hasSharePointAccess)) ?? true;
    } catch (error) {
      hasSharePointAccess = true;
    }

    let sites: ISiteInfoUrl[] = [];

    if (!siteId || advancedSearchStateManager.enableAdvSearchMultiSites) {
      const allowedSites: string[] = advancedSearchStateManager.allowedSiteCollections;
      let [siteResult, teams] = await Promise.all(
        [
          searchSharePointSites({ allowedSites }),
          getJoinedTeams(graphAccessToken)
        ]
      );

      const useDescriptiveName: boolean = siteResult?.sites?.length > 0 || teams?.length > 0;

      if (siteResult?.sites?.length > 0) {
        sites = siteResult.sites
          .map(site => {
            return {
              ...site,
              key: site.id
            };
          });

        // Get all main site subsites
        let subSites: ISubSiteInfo[] = await getSubSites(graphAccessToken, sites.filter(site => !site.isSubsite));
        if (subSites?.length > 0 && allowedSites?.length > 0) {
          subSites = subSites.filter(subSite => allowedSites.some(allowedSite => subSite.name?.trim().toLowerCase() === allowedSite.trim()));
        }

        subSites.forEach(subSite => {
          let existingSubSite: ISiteInfoUrl = sites.find(site => site.id === subSite.id);
          if (!existingSubSite) {
            const parentSiteName: string = sites.find(site => !site.isSubsite && site.id === subSite.parentSiteId)?.name;
            sites.push({
              id: subSite.id,
              name: useDescriptiveName && parentSiteName ? `${subSite.name} - ${parentSiteName}` : subSite.name,
              webUrl: subSite.webUrl,
              isSubsite: true,
              key: subSite.id
            });
          }
        });
      }

      if (teams?.length > 0) {
        const allowedTeams: string[] = advancedSearchStateManager.allowedTeams;
        if (allowedTeams?.length > 0) {
          teams = teams.filter(team => allowedTeams.some(allowedTeam => team.displayName?.trim().toLowerCase() === allowedTeam.trim()));
        }

        const teamChannelSites: ITeamChannelSite[] = await getTeamsChannelSites(teams);
        teamChannelSites?.forEach(channelSite => {
          if (teams.findIndex(team => team.siteId === channelSite.id) === -1) {
            const parentSiteName: string = teams.find(team => team.siteId === channelSite.teamSiteId)?.displayName;
            sites.push({
              id: channelSite.id,
              isSubsite: true,
              isChannel: true,
              name: useDescriptiveName && parentSiteName ? `${channelSite.displayName} - ${parentSiteName}` : channelSite.displayName,
              webUrl: channelSite.webUrl,
              key: channelSite.id,
              teamSiteId: channelSite.teamSiteId
            });
          }
        });
      }

      teams?.forEach((team, index) => {
        let teamSite: ISiteInfoUrl = sites.find(site => site.id === team.siteId);
        if (teamSite) {
          teamSite.isTeam = true;
        }
        else {
          sites.push({
            id: team.siteId,
            name: team.displayName,
            webUrl: team.webUrl,
            isSubsite: false,
            isTeam: true,
            key: "t" + index
          });
        }
      });
      sites = sites.filter(site => ((site.isTeam || site.isChannel) && hasTeamsAccess) || (!site.isTeam && hasSharePointAccess));
    }

    if (siteId && (hubId || sites.findIndex(site => site.id === siteId) === -1)) {
      const teamGroupId = checkValueForUndefined(props.teamGroupId ? props.teamGroupId : await StorageHelper.getItemAsync(advancedSearch.params.teamGroupId));
      const isTeamSite: boolean = teamGroupId?.length > 0;

      let [mainSiteResult, hubSitesResult, subSitesResult, teamChannelSites] = await Promise.all([
        getSharePointSite(siteId),
        hubId ? getHubSiteSites(graphAccessToken, hubId, advancedSearchStateManager.allowedSiteCollections) : [],
        getSharePointSubsite(graphAccessToken, siteId, advancedSearchStateManager.allowedSiteCollections),
        isTeamSite ? getTeamChannelSites(teamGroupId) : []
      ]);

      if (mainSiteResult) {
        const useDescriptiveName: boolean = sites?.length > 0;

        const mainSite: ISiteInfoUrl = {
          id: mainSiteResult.id,
          isSubsite: false,
          name: mainSiteResult.name,
          webUrl: mainSiteResult.webUrl,
          isTeam: isTeamSite,
          key: mainSiteResult.id
        }

        const subSites: ISiteInfoUrl[] = (subSitesResult?.data ?? [])
          .concat(hubSitesResult ?? [])
          .map(subSite => {
            if (sites.findIndex(site => site.id === subSite.id) === -1) {
              const parentSiteName: string = useDescriptiveName
                ? sites.find(site => !site.isSubsite && site.id === subSite.parentSiteId)?.name
                : null;

              return {
                id: subSite.id,
                isSubsite: true,
                name: parentSiteName ? `${subSite.displayName} - ${parentSiteName}` : subSite.displayName,
                webUrl: subSite.webUrl,
                key: subSite.id
              };
            }
            return null;
          })
          .filter(subSite => subSite);

        const channelSites: ISiteInfoUrl[] =
          (teamChannelSites ?? [])
            .map(channelSite => {
              if (sites.findIndex(site => site.id === channelSite.id) === -1) {
                const parentSiteName: string = useDescriptiveName
                  ? sites.find(site => !site.isSubsite && site.id === channelSite.teamSiteId)?.name
                  : null;

                return {
                  id: channelSite.id,
                  isSubsite: true,
                  isChannel: true,
                  name: parentSiteName ? `${channelSite.displayName} - ${parentSiteName}` : channelSite.displayName,
                  webUrl: channelSite.webUrl,
                  key: channelSite.id,
                  teamSiteId: channelSite.teamSiteId
                }
              }
              return null;
            })
            .filter(channelSite => channelSite);

        // sites = sites.concat(mainSite).concat(subSites).concat(channelSites);
        if (sites.findIndex(site => site.id === mainSite.id) === -1) {
          sites = sites.concat(mainSite);
        }
        sites = sites.concat(subSites).concat(channelSites);
      }
    }

    return sites;
  }

  const loadOneDriveRootDetails = async () => {
    try {
      const oneDriveRootDetails = await getOneDriveRootDetails();
      if (oneDriveRootDetails) {
        props.setOneDriveDetails(oneDriveRootDetails);
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (loadOneDriveRootDetails)");
    }
  }

  const getRecentItems = async (initialLoad?: boolean, loadRecentItems?: boolean) => {
    try {
      if (loadRecentItems ?? loadUserRecentItemsRef?.current) {
        !initialLoad && setLoading(prevLoading => ({ ...prevLoading, recentFiles: true }));
        resetQuickFilterValue();
        const recentItemBuilder = new AdvancedSearchRecentItemBuilder();
        const [result] = await Promise.all([
          recentItemBuilder.getRecentItems(),
          loadOneDriveRootDetails()
        ]);
        setSearchResult({
          type: SearchReturnType.RecentItems,
          result: result
        });
        !initialLoad && setLoading(prevLoading => ({ ...prevLoading, recentFiles: false }));
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (getRecentItems)");
    }
  };

  // const setupTokens = async (params: URLSearchParams) => {
  //   let tokens: IAuthTokenResultDto;
  //   const authAccount = await authModule.getAccount(false);
  //   const accountId: string = !props.account ? params.get(shared.params.accountId) : props.account.accountId;
  //   if (!authAccount || authAccount.accountId !== accountId) {
  //     tokens = await authModule.requestTokenSilent(accountId);
  //   }
  //   else {
  //     tokens = await authModule.signIn();
  //   }
  //   return tokens;
  // };

  const setInitialSelectedSite = async (graphToken: any, sites: ISiteInfoUrl[]) => {
    try {
      let uniqueSelectedSites: IUrlKeyNamePair[] = sites.map(site => ({
        key: site.key,
        value: site.name,
        webUrl: site.webUrl,
        siteId: site.id,
        isChannel: site.isChannel,
        teamSiteId: site.teamSiteId
      }));

      if (uniqueSelectedSites?.length > 0) {
        setSelectedSites(uniqueSelectedSites);
        initialSelectedSites = uniqueSelectedSites;
        const documentLibraries = await getDocumentLibraries(uniqueSelectedSites, graphToken);
        setInitialSelectedDocumentLibrary(documentLibraries);
      }
      // const siteId = props.siteId ? props.siteId : await StorageHelper.getItemAsync(advancedSearch.params.siteId);
      // if (siteId) {
      //   // const initialSelectedSite = sites?.find(item => item.id === siteId);
      //   // const currentselectedSites: IUrlKeyNamePair[] = initialSelectedSite
      //   //   ? [
      //   //     ...selectedSites,
      //   //     {
      //   //       key: initialSelectedSite.key,
      //   //       value: initialSelectedSite.name,
      //   //       webUrl: initialSelectedSite.webUrl,
      //   //       siteId: initialSelectedSite.id
      //   //     }
      //   //   ]
      //   //   : [];

      //   // setSelectedSites(currentselectedSites);
      //   // initialSelectedSites = currentselectedSites;
      //   // const documentLibraries = await getDocumentLibraries(currentselectedSites, graphToken);
      //   // setInitialSelectedDocumentLibrary(params, documentLibraries);
      //   const initialSelectedSite = sites?.find(item => item.id === siteId);
      //   if (initialSelectedSite) {
      //     let selectedSubSites: ISiteInfoUrl[] = [];

      //     if (!initialSelectedSite.isSubsite && initialSelectedSite.id) {
      //       // Get all main site's subsites
      //       const mainSiteUniqueIdSections: string[] = initialSelectedSite.id.split(","); // xblox.sharepoint.com,058798cc-59c1-451f-8957-49e32c49aeb1,4c5fa046-b695-4b4b-86ef-b47bb86f7cbe            
      //       if (mainSiteUniqueIdSections?.length === 3) {
      //         const mainSiteUniqueId: string = mainSiteUniqueIdSections.slice(0, 2).join(","); // xblox.sharepoint.com,058798cc-59c1-451f-8957-49e32c49aeb1
      //         selectedSubSites = sites.filter(site => site.isSubsite && site.id?.startsWith(mainSiteUniqueId));
      //       }
      //     }

      //     const currentSelectedSites: IUrlKeyNamePair[] =
      //       [
      //         ...selectedSites,
      //         {
      //           key: initialSelectedSite.key,
      //           value: initialSelectedSite.name,
      //           webUrl: initialSelectedSite.webUrl,
      //           siteId: initialSelectedSite.id
      //         },
      //         ...selectedSubSites.map(subSite => ({
      //           key: subSite.key,
      //           value: subSite.name,
      //           webUrl: subSite.webUrl,
      //           siteId: subSite.id
      //         }))
      //       ];
      //     let uniqueSelectedSites: IUrlKeyNamePair[] = [];
      //     currentSelectedSites.forEach((val) => {
      //       if (uniqueSelectedSites.filter(site => site.siteId === val.siteId).length === 0) {
      //         uniqueSelectedSites.push(val);
      //       }
      //     })
      //     if (uniqueSelectedSites?.length > 0) {
      //       setSelectedSites(uniqueSelectedSites);
      //       initialSelectedSites = uniqueSelectedSites;
      //       const documentLibraries = await getDocumentLibraries(uniqueSelectedSites, graphToken);
      //       setInitialSelectedDocumentLibrary(documentLibraries);
      //     }
      //   }
      // }
    } catch (error) {
      logger(error, "advancedSearch.tsx (setInitialSelectedSite)");
    }
  };

  const setInitialSelectedDocumentLibrary = async (documentLibraries: IDocUrlDropdown[]) => {
    try {
      const documentLibraryId = checkValueForUndefined(await StorageHelper.getItemAsync(advancedSearch.params.documentLibraryId));
      if (documentLibraryId) {
        const initialSelectedDocumentLibrary: IDocUrlDropdown = documentLibraries.find(
          item => item.driveId === documentLibraryId
        );

        if (initialSelectedDocumentLibrary) {
          initialSelectedDocumentLibrary.selected = true;
          const currentSelectedDocumentLibraries = getCurrentSelectedDocumentLibraries(initialSelectedDocumentLibrary);
          setSelectedDocumentLibraries(currentSelectedDocumentLibraries);
          await Promise.all([
            buildContentTypes(currentSelectedDocumentLibraries),
            buildFields(currentSelectedDocumentLibraries)
          ]);
        }
      }
      else {
        autoSelectDocumentLibraries(documentLibraries);
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (setInitialSelectedDocumentLibrary)");
    }
  };

  const autoSelectDocumentLibraries = async (documentLibraries: IDocUrlDropdown[]) => {
    if (documentLibraries?.length > 0) {
      const selectedDocumentLibraries =
        [
          ...selectedDocumentLibrariesRef?.current,
          ...documentLibraries.map(docLib => ({
            key: docLib.key as string,
            driveId: docLib.driveId,
            value: docLib.text,
            webUrl: docLib.webUrl,
            siteId: docLib.siteId,
            documentLibrary: docLib.documentLibrary,
            sharePointListId: docLib.sharePointListId
          }))
        ];
      setSelectedDocumentLibraries(selectedDocumentLibraries);
      await Promise.all([
        buildContentTypes(selectedDocumentLibraries),
        buildFields(selectedDocumentLibraries)
      ]);
    }
  }

  const getCurrentSelectedDocumentLibraries = (selectedItem: IDocUrlDropdown): IDocUrlKeyNamePair[] => {
    try {
      return selectedItem && selectedItem.selected
        ? [
          ...selectedDocumentLibrariesRef?.current,
          {
            key: selectedItem.key as string,
            driveId: selectedItem.driveId,
            value: selectedItem.text,
            webUrl: selectedItem.webUrl,
            siteId: selectedItem.siteId,
            documentLibrary: selectedItem.documentLibrary,
            sharePointListId: selectedItem.sharePointListId
          }
        ]
        : selectedDocumentLibrariesRef?.current.filter(nameValuePair => nameValuePair.driveId !== selectedItem.driveId);
    } catch (error) {
      logger(error, "advancedSearch.tsx (getCurrentSelectedDocumentLibraries)");
      return [];
    }
  };

  const buildSitesDropdown = async (sites: ISiteInfoUrl[], graphToken: string) => {
    try {
      const dropdownItems: any[] = [];
      // const isTeams: boolean = !props.account ? JSON.parse((await StorageHelper.getItemAsync(advancedSearch.params.isTeams))?.toLowerCase()) : false; //must parse to get "true" string to the bool value
      const isTeams: boolean = !sites?.some(site => !site.isSubsite && !site.isTeam);
      const allTopSites = buildSection("mainSiteHeader", isTeams ? "Teams" : "Sites", sites, item => !item.isSubsite);
      if (allTopSites?.items?.length > 0) {
        const teamSites = sites.filter(site => site.isTeam);

        const mainSiteSection = {
          header: allTopSites.header,
          items: allTopSites.items.filter(item => !teamSites.some(tsn => tsn.webUrl === item.webUrl))
        };
        if (mainSiteSection.items?.length > 0) {
          dropdownItems.push(...[mainSiteSection.header], ...mainSiteSection.items);
        }

        const TeamSiteSection =
          teamSites?.length > 0
            ? {
              header: { key: "teamSiteHeader", text: "Teams", itemType: DropdownMenuItemType.Header },
              items: allTopSites.items.filter(item => teamSites.some(tsn => tsn.webUrl === item.webUrl))
            }
            : undefined;

        if (TeamSiteSection) {
          dropdownItems.push(...[TeamSiteSection.header], ...TeamSiteSection.items);
        }

        const subSiteSection = buildSection("subSiteHeader", (sites?.some(site => site.isChannel) ? "Subsites / Channels" : "Subsites"), sites, item => item.isSubsite);
        if (subSiteSection.items?.length > 0) {
          dropdownItems.push(
            ...[subSiteSection.header],
            ...subSiteSection.items
              .map(subSite => ({
                ...subSite,
                isSubSite: true
              }))
              .sort((a, b) => {

                // Sort subsites according to index of parent site.
                let aSortValue: number;
                let bSortValue: number;

                const aSubSiteUniqueIdSections: string[] = a.siteId.split(","); // xblox.sharepoint.com,058798cc-59c1-451f-8957-49e32c49aeb1,4c5fa046-b695-4b4b-86ef-b47bb86f7cbe
                if (aSubSiteUniqueIdSections?.length === 3) {
                  const aSubSiteUniqueId: string = aSubSiteUniqueIdSections.slice(0, 2).join(","); // xblox.sharepoint.com,058798cc-59c1-451f-8957-49e32c49aeb1
                  aSortValue = sites.findIndex(site => !site.isSubsite && site.id?.startsWith(aSubSiteUniqueId));
                }

                const bSubSiteUniqueIdSections: string[] = b.siteId.split(",");
                if (bSubSiteUniqueIdSections?.length === 3) {
                  const bSubSiteUniqueId: string = bSubSiteUniqueIdSections.slice(0, 2).join(",");
                  bSortValue = sites.findIndex(site => !site.isSubsite && site.id?.startsWith(bSubSiteUniqueId));
                }

                return (aSortValue ?? a.key) < (bSortValue ?? b.key) ? -1 : 1;

              }));
        }
      }
      return dropdownItems;
    } catch (error) {
      logger(error, "advancedSearch.tsx (buildSitesDropdown)");
      return [];
    }
  };

  const buildSection = (key: string, text: string, sites: ISiteInfoUrl[], predicate: (item) => unknown) => {
    const header = { key: key, text: text, itemType: DropdownMenuItemType.Header };
    const items = sites.filter(predicate).map(item => ({ key: item.key, text: item.name, webUrl: item.webUrl, siteId: item.id, isChannel: item.isChannel, teamSiteId: item.teamSiteId }));
    return { header: header, items: items };
  };

  const onChangeSites = async (event: React.FormEvent<HTMLDivElement>, item: IUrlDropdown): Promise<void> => {
    try {
      if (item) {
        resetSitesSelection();

        let selectedSubSites: IUrlDropdown[] = [];
        if (!item.isSubSite && item.siteId) {
          // Get all main site's subsites
          const mainSiteUniqueIdSections: string[] = item.siteId.split(","); // xblox.sharepoint.com,058798cc-59c1-451f-8957-49e32c49aeb1,4c5fa046-b695-4b4b-86ef-b47bb86f7cbe
          if (mainSiteUniqueIdSections?.length === 3) {
            const mainSiteUniqueId: string = mainSiteUniqueIdSections.slice(0, 2).join(","); // xblox.sharepoint.com,058798cc-59c1-451f-8957-49e32c49aeb1
            selectedSubSites = sitesDropdown.filter(site => site.isSubSite && ((site.isChannel && site.teamSiteId === item.siteId) || site.siteId?.startsWith(mainSiteUniqueId)));
          }
        }

        let currentSelectedSites: IUrlKeyNamePair[];
        if (!item.selected && selectedSubSites?.length > 0) {
          // Auto deselect/filter out all the main site's sub sites.
          currentSelectedSites = selectedSitesRef.current.filter(site => !selectedSubSites.some(subSite => site.siteId === subSite.siteId));
        }
        else {
          currentSelectedSites = selectedSitesRef.current;
        }

        const updatedSelectedSites = item.selected
          ? [
            ...currentSelectedSites,
            { key: item.key as string, value: item.text, webUrl: item.webUrl, siteId: item.siteId, isChannel: item.isChannel, teamSiteId: item.teamSiteId },
            ...selectedSubSites.map(subSite => ({
              key: subSite.key as string,
              value: subSite.text,
              webUrl: subSite.webUrl,
              siteId: subSite.siteId,
              isChannel: subSite.isChannel,
              teamSiteId: subSite.teamSiteId
            }))
          ]
          : currentSelectedSites.filter(nameValuePair => nameValuePair.siteId !== item.siteId);

        setSelectedSites(updatedSelectedSites);
        setLocalStorage(localStorageKeys.selectedAdvSearchSites, updatedSelectedSites?.map(site => site.siteId));
        if (updatedSelectedSites?.length > 0) {
          const documentLibraries = await getDocumentLibraries(updatedSelectedSites, await authModule.getGraphAccessToken());
          autoSelectDocumentLibraries(documentLibraries);
        }
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (onChangeSites)");
    }
  };

  const getDocumentLibraries = async (currentSelectedSites: IUrlKeyNamePair[], graphToken: string) => {
    try {
      if (!currentSelectedSites.length) return [];
      let documentLibraryItems: IDocUrlDropdown[] = [];
      const emptySites: IUrlKeyNamePair[] = CacheHandler.sitesToUpdate(currentSelectedSites);
      if (emptySites?.length > 0) { //check if any libraries in sites are empty

        const siteLibraries: ISiteDriveItems[] = await getSiteDocumentLibraryDrives(
          graphToken,
          emptySites.map<ISiteBatchInfo>(site => ({ site: site.value, siteId: site.siteId, mainWebUrl: site.webUrl }))
        );

        documentLibraryItems = siteLibraries
          ?.filter(siteLib => siteLib)
          ?.reduce(
            (aggregate, siteLibrary) => [
              ...(aggregate ?? []),
              ...(siteLibrary.driveItems
                ?.filter(item => {
                  const sites: SiteItem[] = advancedSearchStateManager.sites?.filter(site => site.displayName?.trim().toLowerCase() === siteLibrary.site?.trim().toLowerCase());
                  if (sites?.length > 0) {
                    const hiddenDocumentLibraries: documentLibraryItem[] = sites[0]?.documentLibraries?.filter(docLib => docLib.hidden === true);
                    return !hiddenDocumentLibraries.some(hiddenLib => hiddenLib?.title?.trim().toLowerCase() === (item.list?.displayName ?? item.name)?.trim().toLowerCase());
                  }
                  return true;
                })
                ?.map(item => ({
                  text: item.list?.displayName ?? item.name,
                  key: item.id, // driveId
                  driveId: item.id, // driveId
                  webUrl: siteLibrary.mainUrl,
                  siteId: siteLibrary.siteId,
                  documentLibrary: item.list?.displayName ?? item.name,
                  sharePointListId: item.sharePointListId,
                })) ?? [])
            ],
            []
          );
        documentLibraryItems = documentLibraryItems.concat(CacheHandler.getCachedLibraries(currentSelectedSites));
        CacheHandler.setLibraries(currentSelectedSites, documentLibraryItems);

      } else {
        documentLibraryItems = CacheHandler.getCachedLibraries(currentSelectedSites);
      }
      const renameDocItems: IDocUrlDropdown[] = documentLibraryItems
        .filter(lib => {
          const librarySites: IUrlKeyNamePair[] = currentSelectedSites?.filter(site => site.siteId && site.siteId === lib.siteId);
          if (librarySites?.length > 0) {
            const librarySite: IUrlKeyNamePair = librarySites[0];
            const sites: SiteItem[] = advancedSearchStateManager.sites?.filter(site => site.displayName?.trim().toLowerCase() === librarySite.value?.trim().toLowerCase());
            if (sites?.length > 0) {
              const hiddenDocumentLibraries: documentLibraryItem[] = sites[0]?.documentLibraries?.filter(docLib => docLib.hidden === true);
              return !hiddenDocumentLibraries.some(hiddenLib => hiddenLib?.title?.trim().toLowerCase() === lib.documentLibrary?.trim().toLowerCase());
            }
          }
          return true;
        })
        .map(lib => {
          return {
            ...lib,
            text: currentSelectedSites?.length == 1 ? lib.text : lib.text + ' - ' + currentSelectedSites.find(s => s.siteId === lib.siteId).value,
          }
        })
        .sort((a, b) => (a.siteId?.localeCompare(b.siteId || "") || a.text?.localeCompare(b.text || "")));
      setDocumentLibrariesDropdown(renameDocItems);
      return documentLibraryItems;
    } catch (error) {
      logger(error, "advancedSearch.tsx (getDocumentLibraries)");
      return [];
    }
  };

  const resetSitesSelection = () => {
    setSelectedDocumentLibraries([]);
    resetDocumentLibrarySelection();
  };

  const refreshCache = async () => {
    setLoading(prevLoading => ({ ...prevLoading, refreshingCache: true }));
    CacheHandler.clearCache();
    removeLocalStorage(localStorageKeys.selectedAdvSearchSites);
    setSelectedSites([]);
    setSelectedDocumentLibraries([]);
    resetDocumentLibrarySelection();
    //now reload the rest of the cache
    await initSearchFields(true);
    // await Promise.all([
    //   buildContentTypes([]),
    //   buildFields([])
    // ]);
    setLoading(prevLoading => ({ ...prevLoading, refreshingCache: false }));
  }

  const sitesDropdownView = () => {
    return (
      <Dropdown
        placeholder={`${languageStrings.Select} ${languageStrings.Sites}`}
        //label={languageStrings.Sites}
        disabled={loading.refreshingCache}
        onRenderCaretDown={(_, defaultRender) => {
          return loading.refreshingCache ?
            <Stack verticalAlign="center" style={{ height: "100%" }}>
              <Spinner size={SpinnerSize.small} />
            </Stack>
            : defaultRender();
        }}
        onRenderLabel={() => {
          return (
            <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
              <Label>
                {languageStrings.Sites}
              </Label>
              <TooltipHost
                content={languageStrings.Refresh}
                styles={{
                  root: {
                    display: "inline-block",
                  }
                }}
                calloutProps={{
                  gapSpace: 0
                }}
              >
                <Icon
                  iconName="refresh"
                  styles={{
                    root: {
                      cursor: "pointer",
                      ":hover": {
                        backgroundColor: theme.palette.neutralLighter,
                      },
                      paddingTop: 2,
                      paddingBottom: 2,
                      paddingLeft: 2,
                      paddingRight: 2,
                    }
                  }}
                  onClick={async () => await refreshCache()}
                />
              </TooltipHost>
            </Stack>
          )
        }}
        selectedKeys={selectedSitesRef.current.map(site => site.key)}
        multiSelect
        onChange={onChangeSites}
        options={sitesDropdown}
        styles={dropdownStyles}
        // responsiveMode={ResponsiveMode.small}
        className="xb-sp-input"
      />
    )
  };

  const onChangeDocumentLibraries = async (
    _event: React.FormEvent<HTMLDivElement>,
    item: IDocUrlDropdown
  ): Promise<void> => {
    if (item) {
      setIsInputsLoading(true);
      resetDocumentLibrarySelection();
      const currentSelectedDocumentLibraries = getCurrentSelectedDocumentLibraries(item);
      setSelectedDocumentLibraries(currentSelectedDocumentLibraries);
      await Promise.all([
        buildContentTypes(currentSelectedDocumentLibraries),
        buildFields(currentSelectedDocumentLibraries)
      ]);
      setIsInputsLoading(false);
    }
  };

  const resetDocumentLibrarySelection = () => {
    setFields([]);
    setContentTypesDropdown([]);
    setSelectedContentTypes([]);
    setAllUsers([]);
  };

  const buildContentTypes = async (currentSelectedDocumentLibraries: IDocUrlKeyNamePair[]) => {
    if (advancedSearchStateManager.disableAdvSearchContentTypes) return;
    try {
      if (!(advancedSearchStateManager.allowedAdvancedSearchFields?.length > 0)
        || advancedSearchStateManager.allowedAdvancedSearchFields.find(allowedField => allowedField === "contenttype")) {
        let contentTypeItems: IDocUrlDropdown[] = [];
        const emptyLibs: IDocUrlDropdown[] = CacheHandler.getEmptyContentLibs(currentSelectedDocumentLibraries);
        const cachedContentTypeItems = CacheHandler.getCachedContentTypes(currentSelectedDocumentLibraries);
        if (emptyLibs.length > 0) {

          const documentLibraryWithContentTypes = await SharePointCompositeService.getDocumentLibrariesWithContentTypes(
            emptyLibs.map(item => ({
              webUrl: item.webUrl,
              documentLibrary: item.documentLibrary,
              siteId: item.siteId,
              sharePointListId: item.sharePointListId
            }))
          );

          contentTypeItems = documentLibraryWithContentTypes.reduce(
            (aggregate, docLibrary) => [
              ...aggregate,
              ...docLibrary.contentTypes.map(item => ({
                text: `${item.text} - ${docLibrary.documentLibrary}`,
                key: item.key,
                webUrl: docLibrary.webUrl,
                documentLibrary: docLibrary.documentLibrary,
                sharePointListId: docLibrary.sharePointListId
              }))
            ],
            []
          );

          contentTypeItems = contentTypeItems.concat(cachedContentTypeItems);
          CacheHandler.setContentTypeItems(contentTypeItems);
        } else {
          contentTypeItems = cachedContentTypeItems;
        }
        setContentTypesDropdown(contentTypeItems);

      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (buildContentTypes)");
    }
  };

  const buildFields = async (currentSelectedDocumentLibraries: IDocUrlKeyNamePair[]) => {
    try {
      const sharepointToken = await authModule.getSharePointAccessToken();

      let fields: IAdvancedSearchFields[][] = [];
      const emptyLibs: IDocUrlKeyNamePair[] = CacheHandler.getEmptyFieldsLibs(currentSelectedDocumentLibraries);
      const cachedFields = CacheHandler.getCachedFields(currentSelectedDocumentLibraries);
      if (emptyLibs.length > 0) {
        fields = await Promise.all(
          emptyLibs.map(
            async item =>
              await SharepointDocumentLibraryHelper.getDocumentLibraryFields(sharepointToken, {
                webUrl: item.webUrl,
                siteId: item.siteId,
                documentLibrary: item.documentLibrary,
                sharePointListId: item.sharePointListId
              })
          )
        );
        //concat fields with cache fields
        fields = fields.concat(cachedFields);
        //save fields to cache
        CacheHandler.setFields(fields);
      } else {
        //get searchFields from cache
        fields = cachedFields;
      }

      let uniqueFields = groupFields(fields).map(f => {
        return {
          ...f,
          sortVal: SortValEnum[f.xml?.Type?.toLowerCase().trim() !== "calculated"
            ? f.xml?.Type?.toLowerCase().trim()
            : f.xml.ResultType.toLowerCase()] ?? SortValEnum.other
        };
      });
      if (advancedSearchStateManager.allowedAdvancedSearchFields?.length > 0) {
        uniqueFields = advancedSearchStateManager.allowedAdvancedSearchFields
          .map(allowedField => {
            return uniqueFields.find(uniqueField => uniqueField?.xml?.DisplayName?.trim().toLowerCase() === allowedField.trim())
          })
          .filter(allowedField => allowedField);
      }
      else {
        // uniqueFields.sort((a, b) => a.sortVal < b.sortVal ? -1 : 1);
        uniqueFields.sort((a, b) => a.sortVal - b.sortVal || a.xml?.DisplayName - b.xml?.DisplayName);
      }
      if (uniqueFields?.length > 0) {
        uniqueFields = uniqueFields.map(f => {
          delete f.sortVal;
          return f;
        });
        setInputValues(uniqueFields);
        const peoplePickersFields = uniqueFields
          .map(item => item.xml.Type)
          .filter(item => validPeoplePickerTypes.some(vppt => vppt === item));

        const hasPeoplePickerFields = peoplePickersFields.length > 0;
        if (hasPeoplePickerFields) {
          await getAllUsers(!selectedSitesRef.current.length ? initialSelectedSites : selectedSitesRef.current);
        }

        advancedSearchStateManager.setDatasourceFields(!selectedSitesRef.current.length ? initialSelectedSites : selectedSitesRef.current, currentSelectedDocumentLibraries);
        setFields(uniqueFields);
      }

    } catch (error) {
      logger(error, "advancedSearch.tsx (buildFields)");
    }
  };

  const getAllUsers = async (selectedSites: IUrlKeyNamePair[]) => {
    try {
      const peopleService = new PeopleCompositeServices(selectedSites.map(site => site.webUrl));
      const users = await peopleService.getAllUsers();
      setAllUsers(users);
    } catch (error) {
      logger(error, "advancedSearch.tsx (getAllUsers)");
    }
  };

  const setInputValues = (fields: any[]) => {
    try {
      let inputValuesToSearchFields: ISharepointSearchInput[] = fields.map(FieldHelper.setupInputValues);
      const inputValuesToSearchFieldsupdated = FieldHelper.addMissingField(
        inputValuesToSearchFields,
        internalSharepointName.contentTypeId,
        "Content"
      );
      setInputValuesToSearch(inputValuesToSearchFieldsupdated);
    } catch (error) {
      logger(error, "advancedSearch.tsx (setInputValues)");
    }
  };

  const documentLibrariesDropdownView = selectedSitesRef.current.length > 0 && (
    <Dropdown
      placeholder={`${languageStrings.Select} ${languageStrings.DocumentLibraries}`}
      label={languageStrings.DocumentLibraries}
      selectedKeys={selectedDocumentLibrariesRef?.current.map(lib => lib.key)}
      multiSelect
      onChange={onChangeDocumentLibraries}
      options={documentLibrariesDropdown}
      styles={dropdownStyles}
      // responsiveMode={ResponsiveMode.small}
      className="xb-sp-input"
    />
  );

  const onChangeContentTypes = async (event: React.FormEvent<HTMLDivElement>, item: IDocUrlDropdown): Promise<void> => {
    try {
      if (item) {
        const currentSelectedContentTypes = item.selected
          ? [
            ...selectedContentTypes,
            {
              key: item.key as string,
              value: item.text,
              webUrl: item.webUrl,
              documentLibrary: item.documentLibrary,
              sharePointListId: item.sharePointListId
            }
          ]
          : selectedContentTypes.filter(nameValuePair => nameValuePair.key !== item.key);

        setSelectedContentTypes(currentSelectedContentTypes);
        const index = inputValuesToSearchRef?.current.findIndex(item => item.internalName === internalSharepointName.contentTypeId);
        handleValueChange(
          index,
          currentSelectedContentTypes.map(item => item.key)
        );

        // const contentTypeFields = await getContentTypeFields(currentSelectedContentTypes);
        // compareFields(contentTypeFields);
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (onChangeContentTypes)");
    }
  };

  const getContentTypeFields = async (currentSelectedContentTypes: IDocUrlKeyNamePair[]) => {
    try {
      const token = await authModule.getSharePointAccessToken();
      return await Promise.all(
        currentSelectedContentTypes.map(
          async item =>
            await SharepointDocumentLibraryHelper.getContentTypeFields(
              token,
              {
                webUrl: item.webUrl,
                siteId: item.siteId,
                documentLibrary: item.documentLibrary,
                sharePointListId: item.sharePointListId
              },
              item.key
            )
        )
      );
    } catch (error) {
      logger(error, "advancedSearch.tsx (getContentTypeFields)");
      return [];
    }
  };

  const compareFields = (contentTypeFields: any[]) => {
    const contentTypeFieldsReduced = contentTypeFields.reduce((pn, u) => [...pn, ...u], []);
    let missingFields: ISharepointSearchInput[] = contentTypeFieldsReduced
      .filter(contentTypeField => !fields.some(field => field.InternalName === contentTypeField.InternalName))
      .map(FieldHelper.setupInputValues);

    if (advancedSearchStateManager.allowedAdvancedSearchFields?.length > 0) {
      missingFields = advancedSearchStateManager.allowedAdvancedSearchFields
        .map(allowedField => missingFields.find(uniqueField => uniqueField?.xml?.DisplayName?.trim().toLowerCase() === allowedField.trim()))
        .filter(allowedField => allowedField);
    }

    if (missingFields?.length > 0) {
      setFields([...fields, ...missingFields]);
    }
  };

  const groupFields = (fields: any[]) => {
    const normalFields = fields.reduce((agg, current) => [...agg, ...current], []);
    const values = GroupByHelper.groupBy(normalFields, current => {
      return `${current.xml.DisplayName}${current.xml.Type}`;
    });

    return GroupByHelper.getUniqueValues(values);
  };

  const contentTypesDropdownView = !advancedSearchStateManager.disableAdvSearchContentTypes && selectedDocumentLibrariesRef?.current.length > 0 && contentTypesDropdown.length > 0 && (
    <Dropdown
      placeholder={`${languageStrings.Select} ${languageStrings.ContentTypes}`}
      label={languageStrings.ContentTypes}
      selectedKeys={selectedContentTypes.map(lib => lib.key)}
      multiSelect
      onChange={onChangeContentTypes}
      options={contentTypesDropdown}
      styles={dropdownStyles}
      // responsiveMode={ResponsiveMode.small}
      className="xb-sp-input"
    />
  );

  const search = async () => {
    try {
      resetQuickFilterValue();
      if (!inputValuesToSearchRef?.current.filter(item => item.value).length) {
        setSearching({ isSearching: false, hasSearchedBefore: true });
        setSearchResult({
          type: null,
          result: [],
        });
        loadUserRecentItemsRef?.current && setBreadCrumbItems([
          { text: languageStrings.Recent, key: "Recent", href: "#", onClick: resetBreadCrumbs },
          { text: languageStrings.Search, key: "Search", href: "#" }
        ]);
        return;
      }

      setSearching(prevSearching => ({ ...prevSearching, isSearching: true }));
      const token = await authModule.getSharePointAccessToken();
      const builder = new DocumentSearchRequestBuilder();
      const result = await Promise.all(
        selectedDocumentLibrariesRef?.current.map(item => getDocumentSearchResult(builder, item, token))
      );

      const gridData = result
        .reduce((pn, u) => [...pn, ...u], [])
        .map(item => {
          const { fields, ...restOfProperties } = item;
          return { ...restOfProperties, ...KeyValuePairHelper.buildKeyValuePairs(fields) };
        });
      if (loadUserRecentItemsRef?.current) {
        setBreadCrumbItems([
          { text: languageStrings.Recent, key: "Recent", href: "#", onClick: resetBreadCrumbs },
          { text: languageStrings.Search, key: "Search", href: "#" },
        ]
        );
      }

      // gridData.forEach(data => {
      //   const site = selectedDocumentLibrariesRef?.current.find(x => x.driveId === data.driveId);
      //   data['siteUrl'] = site.webUrl;
      // });

      setSearchResult({
        type: SearchReturnType.SearchResult,
        result: gridData,
      });

      // if (advancedSearchStateManager.enablePII === true) {
      //   for (let index = 0; index < gridData.length; index++) {
      //     const selectedFile = gridData[index];

      //     if (selectedFile && selectedFile[piiConfig.privacySentitiveDataColumnName]?.value === null) {
      //       checkPiiMutation({
      //         accessToken: await authModule.getSharePointAccessToken(),
      //         fileUrl: selectedFile.webUrl,
      //         siteUrl: selectedFile['siteUrl'],
      //         forceRecheck: true
      //       })
      //         .unwrap()
      //         .then(res => {
      //           selectedFile[piiConfig.privacySentitiveColumnName].value = res.piiDetected ? "True" : "False";
      //           selectedFile[piiConfig.privacySentitiveDataColumnName].value = res.pii;
      //           setSearchResult({
      //             type: SearchReturnType.SearchResult,
      //             result: [...gridData],
      //           });
      //         }).catch(error => {
      //           selectedFile[piiConfig.privacySentitiveColumnName].value = "False";
      //           selectedFile[piiConfig.privacySentitiveDataColumnName].value = languageStrings.PrivacySensitiveCheckError
      //           setSearchResult({
      //             type: SearchReturnType.SearchResult,
      //             result: [...gridData],
      //           });
      //         });
      //     }
      //   }
      // }

    } catch (error) {
      logger(error, "advancedSearch.tsx (search)");
      setSearchResult({
        type: SearchReturnType.SearchResult,
        result: [],
      });
    }

    setSearching({ isSearching: false, hasSearchedBefore: true });
  };

  const recheckPii = async (selectedFiles: any, redactPiiData: boolean) => {
    selectedFiles.items.forEach(async selectedFile => {

      if (selectedFile[piiConfig.privacySentitiveColumnName.toLowerCase()] !== undefined && !selectedFile.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder)) {
        const gridFile = searchResult.result.find(x => x.driveId === selectedFile.driveid && x.webUrl === selectedFile.weburl);
        if ((gridFile && !redactPiiData) || (gridFile && redactPiiData && gridFile[piiConfig.privacySentitiveColumnName].value === 'True' && getExtension(gridFile.name)?.toLowerCase() === extensions.pdf)) {
          gridFile[piiConfig.privacySentitiveColumnName].value = "False";
          gridFile[piiConfig.privacySentitiveDataColumnName].value = null;
          setSearchResult({
            type: SearchReturnType.SearchResult,
            result: [...searchResult.result],
          });

          try {
            const piiResults = await checkPiiMutation({
              accessToken: await authModule.getSharePointAccessToken(),
              fileUrl: selectedFile.weburl,
              siteUrl: selectedFile['siteurl'],
              forceRecheck: true,
              redactPiiData
            })
              .unwrap();

            gridFile[piiConfig.privacySentitiveColumnName].value = piiResults.piiDetected ? "True" : "False";

            if (piiResults.piiError) {
              gridFile[piiConfig.privacySentitiveDataColumnName].value = languageStrings.PrivacySensitiveCheckError
            } else {
              gridFile[piiConfig.privacySentitiveDataColumnName].value = piiResults.pii;
            }
          } catch (error) {
            gridFile[piiConfig.privacySentitiveColumnName].value = "False";
            gridFile[piiConfig.privacySentitiveDataColumnName].value = languageStrings.PrivacySensitiveCheckError
          }


          setSearchResult({
            type: SearchReturnType.SearchResult,
            result: [...searchResult.result],
          });
        }
      }
    });
  }

  const metaDataUpdated = async (selectedItem: any, inputValuesToSave: SharePointInputData[]) => {
    try {
      const gridFile = searchResult.result.find(x => x.driveId === selectedItem.driveid && x.webUrl === selectedItem.weburl);
      if (gridFile) {
        inputValuesToSave.forEach(inputValue => {
          if (inputValue.internalName === sharePointInternalFileName) {
            if (!selectedItem.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder)) {
              gridFile.name = `${inputValue.value}.${getExtension(selectedItem.name)}`;
            } else {
              gridFile.name = inputValue.value;
            }
          } else {
            // if (gridFile[inputValue.internalName]) {
            //   gridFile[inputValue.internalName].value = inputValue.value;
            // }
            const propertyInternalName: string = inputValue.internalName.replaceAll("_x0020_", " ");
            if (gridFile[propertyInternalName]) {
              gridFile[propertyInternalName].value = inputValue.value;
            }
          }
        });

        setSearchResult({
          type: SearchReturnType.SearchResult,
          result: [...searchResult.result],
        });
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (metaDataUpdated)");
    }
  }

  const fileRenamed = async (selectedItem: any, updatedValue: string) => {
    try {
      const gridFile = searchResult.result.find(x => x.driveId === selectedItem.driveid && x.webUrl === selectedItem.weburl);
      if (gridFile) {
        gridFile.name = updatedValue;

        setSearchResult({
          type: SearchReturnType.SearchResult,
          result: [...searchResult.result],
        });
      }
    } catch (error) {
      logger(error, "advancedSearch.tsx (fileRenamed)");
    }
  }

  const filesDeleted = async (selectedItems: any[]) => {
    try {
      const newRows: any[] = [];
      searchResult.result.forEach((item, index) => {
        const isSelected = selectedItems.find(x => x.key === index);
        if (!isSelected) {
          newRows.push(item);
        }
      });

      setSearchResult({
        type: SearchReturnType.SearchResult,
        result: [...newRows],
      });
    } catch (error) {
      logger(error, "advancedSearch.tsx (filesDeleted)");
    }
  }

  const openApprovalsPanel = async (selectedFiles: any) => {
    setApprovalFiles(selectedFiles);
    setIsApprovalsPanelOpen(true);
  }

  const { quickFilterCommandInput, resetQuickFilterValue } = useQuickFilterCommandInput(setFilterValue);

  const searchGrid =
    <SearchGrid
      isLoading={searching.isSearching || loading.recentFiles}
      adjustHeightForBreakCrumb={loadUserRecentItemsRef?.current}
      searchResult={filterValue?.length
        ? {
          type: SearchReturnType.SearchResult,
          result: searchResult?.result.filter(result => {
            const resultProperties = Object.keys(result);
            return resultProperties.some(property => {
              try {
                let propertyValue: string;
                const propertyType: string = result[property]?.type;
                if (propertyType && (propertyType === "DateTime" || propertyType === "DateOnly")) {
                  const unixValue: number = Number(result[property]?.value);
                  if (unixValue) {
                    const unixDate = dayjs.unix(unixValue);
                    propertyValue = propertyType === "DateOnly" ? unixDate.format("L") : unixDate.format("L LT");;
                  }
                }
                else {
                  propertyValue = (result[property].value !== undefined ? result[property].value.toString() : result[property].toString()).toLowerCase();
                }
                return propertyValue?.includes(filterValue.trim().toLowerCase());
              } catch (error) {
                // Do not log to generic logger as it may flood the db.
                console.error(error);
              }
              return true;
            });
          })
        }
        : searchResult
      }
      viewsDropdownItems={viewsDropdownItems}
      fields={fields}
      selectedSites={[...selectedSitesRef.current].sort((a, b) => {
        return a.webUrl.split('/').length - b.webUrl.split('/').length
      })} //this sorts the sites based on how "nested" the site is. main sites are 1st, sub sub sub sites are at the bottom.
      allowOpenInSharePoint={allowOpenInSharePoint}
      enablePII={advancedSearchStateManager.enablePII}
      enableRedaction={advancedSearchStateManager.enableRedaction}
      tenantEnableApprovalHooks={advancedSearchStateManager.tenantEnableApprovalHooks}
      recheckPii={recheckPii}
      openApprovalsPanel={openApprovalsPanel}
      isInConentMangerMode={props.isInConentMangerMode}
      openDocumentsInClientApp={advancedSearchStateManager.openDocumentsInClientApp}
      enableSharing={advancedSearchStateManager.enableSharing}
      metaDataUpdated={metaDataUpdated}
      documentLibraries={documentLibrariesDropdown}
      filesDeleted={filesDeleted}
      fileRenamed={fileRenamed}
      filterCommandItem={searchResult?.result?.length > 0 && quickFilterCommandInput}
      userAccount={currentUserAccount}
    />;

  const getDocumentSearchResult = async (
    builder: DocumentSearchRequestBuilder,
    docLib: IDocUrlKeyNamePair,
    accessToken: string
  ) => {
    const documentSearchRequest = builder.build(
      docLib,
      inputValuesToSearchRef?.current.filter(item => item.value),
      accessToken
    );

    try {
      const result: IDocumentSearchResult[] = await apiSearchDocuments(documentSearchRequest);

      return !result ? [] : result.map(item => ({ ...item, driveId: docLib.driveId, siteUrl: docLib.webUrl }));
    } catch (error) {
      logger(error?.response?.data, "advancedSearch.tsx (getDcoumentSearchResult)");
      return [];
    }
  };

  const searchButton = selectedDocumentLibrariesRef?.current.length > 0 && fields.length > 0 && (
    <PrimaryButton text={languageStrings.Search} onClick={() => search()} allowDisabledFocus>
      {searching.isSearching && <Spinner size={SpinnerSize.small} />}
    </PrimaryButton>
  );

  const handleValueChange = (index: number, value: any) => {
    if (index >= 0 && inputValuesToSearchRef?.current?.length > 0) {
      const updatedInputValuesToSearch = [...inputValuesToSearchRef?.current];
      updatedInputValuesToSearch[index].value = value;
      setInputValuesToSearch(updatedInputValuesToSearch);
    }
  };

  const fieldInputs = fields.map((item, index) => {
    const factory = new InputTypeFactory();
    const inputType = factory.getInputType(item.xml, advancedSearchStateManager.datasourceFields ?? []);
    const users = validPeopleInputTypes.some(item => item === inputType) ? allUsers : [];
    const properties: IInputCreator = {
      type: inputType,
      info: factory.getInfo(
        item,
        inputType,
        inputValuesToSearchRef?.current[index],
        users,
        handleValueChange,
        selectedSitesRef.current?.map(s => s?.value?.trim())?.filter(s => s),
        selectedDocumentLibrariesRef.current?.map(l => l?.documentLibrary?.trim())?.filter(l => l))
    };

    return (
      <Stack.Item key={index} styles={sharedStackItemStyles}>
        <InputCreator {...properties} />
      </Stack.Item>
    );
  });

  const inputsLoader = isInputsLoading && (
    <div style={{ marginTop: "200px" }}>
      <Spinner label={languageStrings.LoadingInputs} />
    </div>
  );

  const ProfileIcon = (profilePicURL: string) => {
    return (
      <div
        style={{ paddingRight: 16, cursor: "pointer" }}
        onClick={() => { setProfilePanelIsOpen(true) }}
      >
        <Persona
          imageUrl={profilePicURL}
          text={props.account?.displayName}
          hidePersonaDetails
          size={PersonaSize.size32}
        />
      </div>
    )
  }

  return loading.sites ? (
    <Stack verticalAlign="center" horizontalAlign="center" styles={initStackStyles}>
      <span className={mergeStyles(sharedStackItemStyles.root)}>
        <Spinner label="Initializing advanced search..." />
      </span>
    </Stack>
  ) : (
    <>
      <Stack horizontal verticalAlign="center" horizontalAlign="space-between" styles={headerStackStyles}>
        {appLogo && <Stack.Item align="center" styles={headerLogoStackItemStyles}>
          <img src={appLogo} className="header-logo" />
          <div style={{ paddingLeft: 10, alignSelf: "center" }}><Text variant="large" className={headerTextStyles}>{`|  ${languageStrings.AdvancedSearch}`}</Text></div>
        </Stack.Item>}
        {!appLogo && <Stack.Item align="center" styles={headerStackItemStyles}>
          <Text variant="large" className={headerTextStyles}>{languageStrings.AdvancedSearch}</Text>
        </Stack.Item>}
        {props.account && !props.isInConentMangerMode && ProfileIcon(profilePic)}
        {props.account && props.isInConentMangerMode &&
          <ActionButton iconProps={{ iconName: 'ChromeClose' }} onClick={() => { props.setMode(!props?.teamsContext ? ModeEnum.contentManager : ModeEnum.contentManagerTeams) }} styles={getCloseButtonStyles(appColor)} />
        }
      </Stack>
      <Stack horizontal tokens={outerStackTokens}>
        <Stack.Item styles={inputContainerStackItemStyles}>
          <Stack id="searchFieldContainer" horizontalAlign="center" tokens={inputStackTokens} styles={inputStackItemStyles}>
            <Stack.Item styles={sharedStackItemStyles}>{sitesDropdownView()}</Stack.Item>
            <Stack.Item styles={sharedStackItemStyles}>{documentLibrariesDropdownView}</Stack.Item>
            {contentTypesDropdownView && <Stack.Item styles={sharedStackItemStyles}>{contentTypesDropdownView}</Stack.Item>}
            {fieldInputs}
            {inputsLoader}
            {searchButton}
          </Stack>
        </Stack.Item>
        <Stack.Item grow>
          {loadUserRecentItemsRef?.current && <Breadcrumb
            items={breadCrumbItems}
            ariaLabel="With last item rendered as heading"
            overflowAriaLabel="More links"
          />}
          {!searching.isSearching && !loading.recentFiles && !searchResult?.result?.length ? (
            <Stack verticalAlign="center" horizontalAlign="center" styles={initStackStyles}>
              <Stack.Item align="center">
                <img src={searchIconSrc} />
              </Stack.Item>
              {searching.hasSearchedBefore && <Stack.Item align="center">
                <Text>{languageStrings.NoItemsFound}</Text>
              </Stack.Item>}
            </Stack>
          ) : (
            searchGrid
          )}
        </Stack.Item>
      </Stack>
      {profilePanelIsOpen &&
        <ProfilePanel
          isOpen={profilePanelIsOpen}
          closePanel={() => setProfilePanelIsOpen(false)}
          profilePicURL={profilePic}
        />
      }
      {isApprovalsPanelOpen && <WebPanel isOpen={isApprovalsPanelOpen} closePanel={() => setIsApprovalsPanelOpen(false)} headerText={languageStrings.AutomationFlowRequest} styles={{ main: { overflow: "unset" } }}>
        <AutomationPanel
          files={approvalFiles}
          isGraphQuery={true}
          tenantEnablePII={advancedSearchStateManager.enablePII}
          closeClicked={() => setIsApprovalsPanelOpen(false)}
          tenantGuid={currentUserAccount.tenantId}
          requestor={currentUserAccount.username}
        />
      </WebPanel>}
    </>
  );
};

export default connector(AdvancedSearch);
